import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modal-origin-lead',
  templateUrl: './modal-origin-lead.component.html',
  styleUrls: ['./modal-origin-lead.component.scss']
})
export class ModalOriginLeadComponent implements OnInit {
  @Input() facItem;
  @Output() closeModal = new EventEmitter<void>();

  @Input() featureProductSheet: boolean;
  public productUrl: string;
  ngOnInit(): void {
    if (this.featureProductSheet) {
      this.productUrl = '/produtos/ficha/' + this.facItem.origin_product.sku
    } else {
      this.productUrl = this.facItem.origin_product.url
    }
    if (!this.facItem.origin_product) {
      this.facItem.origin_product = {};
    }
  }

}
